export enum TemplateTypes {
    Default = 'default',
    Basic = 'basic',
}
